import { Button } from "@mui/material";

import { useFeatureFlag } from "hooks/useFeatureFlag";
import { useConfirmation } from "hooks/useConfirmation";

export default function FeatureFlagButton({ featureFlag }: { featureFlag: string }) {
  const { enabled, toggleFeatureFlag } = useFeatureFlag(featureFlag);
  const { confirm } = useConfirmation();
  return (
    <>
      <Button
        variant="contained"
        color="primary"
        onClick={() =>
          confirm({
            handler: toggleFeatureFlag,
            message: `Are you sure you want to ${enabled ? "disable" : "enable"} the ${featureFlag} feature flag?`,
          })
        }
      >
        {enabled ? "Disable" : "Enable"}
      </Button>
    </>
  );
}
